import { supabase } from '../../supabase';

export async function ensureDigitalOrderNotification(userId: string, newOrder: any) {
  try {
    const { data: existingNotif } = await supabase.from('notifications')
      .select('id')
      .eq('user_id', userId)
      .filter('metadata->>order_id', 'eq', String(newOrder.id))
      .limit(1);
    if (!existingNotif?.length) {
      // DB CHECK notifications_type_check tidak mengizinkan 'DIGITAL_ORDER_NEW'
      // → pakai 'ORDER_NEW' + metadata.event_type agar tidak 400.
      await supabase.from('notifications').insert({
        user_id: userId,
        type: 'ORDER_NEW',
        title: 'Pesanan Digital Baru',
        message: `📱 Pesanan digital baru dari ${newOrder.customerName || 'Pelanggan'} - Rp${(newOrder.totalPrice || 0).toLocaleString('id-ID')}`,
        is_read: false,
        is_deleted: false,
        metadata: { order_id: newOrder.id, event_type: 'digital_order_new' }
      });
    }
  } catch (err) {
    console.debug('[NotificationContext] Digital notification insert failed:', err);
  }
}
